import React, {useRef, useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import Breadcrumb from 'layouts/main/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import PageContainer from "../../../layout/PageContainer";
import LayoutAside from "../../../layout/LayoutAside";
import StringUtil from "utils/StringUtil";
import CommonUtil from "utils/CommonUtil";
import DateUtil from "../../../../utils/DateUtil";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UIUtils from "../../../../utils/UIUtils";
function ContentsContainer() {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const paramJson = useRef<string>("");
	let pageNum = useRef<number>(1);
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	const [dateNum,setDateNum] = useState(0); //날짜 기본값

	const [totalInAmt, setTotalInAmt] = useState(0);
	const [totalOutAmt, setTotalOutAmt] = useState(0);
	const [totalRefundAmt, setTotalRefundAmt] = useState(0);

	/** 검색조건 */
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [inoutGubun, setInoutGubun] = useState('');
	const [vacctNo,setVacctNo] = useState('');
	const [refundCheckYn, setRefundCheckYn] = useState('');

	const [acctNoA, setAcctNoA] = useState('');
	const [acctNoB, setAcctNoB] = useState('');

	//초기 데이터 설정
	const rowCnt = useRef<string>("20");
	const totalCnt = useRef<string>("");
	let defaultRowCnt = 20;


	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},


			"Cols": [
				{"Header": "NO","Type": "Int",	"Name": "SEQ",	"RelWidth": "0.5","Align": "Center","CanEdit": 0},
				{"Header": "거래일시","Type": "Text","Name": "ACCT_DATE","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "계좌구분","Type": "Text","Name": "ACCT_TYPE","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "계좌번호","Type": "Text","Name": "VACCT_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "입금액","Type": "Int","Name": "IN_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출금액","Type": "Int","Name": "OUT_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Align": "Center", "Header": "입출금내역","Type": "Html","Name": "SELECT","RelWidth": 2, "HtmlPostfix" : '<button class="bt" data-color="pri" data-size="tn" type="button">명세서</button>'}
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('init');
			},
			onRenderFinish : function(evtParam){
				if(receivedData !=undefined ){
					if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
    		},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					if(evtParam.col == "SELECT" ){
						var sheet = evtParam.sheet;
						var row = sheet.getFocusedRow();

						getOzReportInvoice(
							row.ACCT_DATE,
							StringUtil.formatNumber(Number(row.IN_AMT))+'원',
							StringUtil.formatNumber(Number(row.OUT_AMT))+'원',
							row.VACCT_NO
						);

					}
				}



			},
			onAfterSort:function(evtParam){
				// @ts-ignore
				sheet.goToPageByIndex(1);
				if(evtParam.sheet.getShownRows().length != 0){
					// @ts-ignore
					sheet.focus(evtParam.sheet.getShownRows()[0], "SEQ");
				}
			},
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					_data = JSON.stringify(d.slice(0, defaultRowCnt), null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}

			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			if(receivedData !=undefined ){
				if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}


			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "통합정보조회"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])



	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			rowCnt.current = e.target.value;
			receivedData.PARAM_ROW_CNT = e.target.value;
			pageNum.current = 1;
			ib.create();

		}else if(e.target.name === 'refundCheckYn') {
			if(e.target.value == ''){
				setVacctNo('');
			}
			setRefundCheckYn(e.target.value);
			if(e.target.value == 'N') setVacctNo(acctNoA)
			else if(e.target.value == 'Y') setVacctNo(acctNoB)
		}


	};


	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_PAGE, PARAM_ROW_CNT};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2201',
			state: { data: dataToSend }
		});
	}

	const setSearchData = (type:string) => {
		let param:any = {};
		let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");

		param = {
			"ST_DATE":sDt,
			"EN_DATE":eDt,
			"INOUT_GUBUN":inoutGubun,
			"VACCT_NO":vacctNo,
			"REFUND_CHECK_YN":refundCheckYn
		};

		if(type == 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData != undefined && receivedData.PARAM_DATA != undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.ST_DATE != '') setStartDate(new Date(param.ST_DATE));
				if(param.EN_DATE != '') setEndDate(new Date(param.EN_DATE));
				if(param.INOUT_GUBUN != '') setInoutGubun(param.INOUT_GUBUN);
				if(param.VACCT_NO != '') setVacctNo(param.VACCT_NO);
				if(param.REFUND_CHECK_YN != '') setRefundCheckYn(param.REFUND_CHECK_YN);
				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		}
		pageNum.current = 1;
		paramJson.current = JSON.stringify(param);

		paramSetting();

		return param;
	}


	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let param:any = {};

		param = setSearchData(sAction);

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2201',
			data: param
		})
		let acctList = response.REC1;
		if(acctList.length != 0){
			for(let i = 0; i < acctList.length; i++){
				if(acctList[i].ACCT_TYPE == 'A'){
					setAcctNoA(acctList[i].VACCT_NO_DES);
				}else if(acctList[i].ACCT_TYPE == 'B'){
					setAcctNoB(acctList[i].VACCT_NO_DES);
				}
			}
		}

		//전체데이터
		let result = response.REC;

		let inSum = response.REC.reduce((total, amt) => {
			if(amt.ACCT_TYPE =='출연계좌') return Number(amt.IN_AMT) + total
			else return total
		}, 0);
		setTotalInAmt(inSum);

		let outSum = response.REC.reduce((total, amt) => {
			if(amt.ACCT_TYPE =='출연계좌') return Number(amt.OUT_AMT) + total
			else return total
		}, 0);
		setTotalOutAmt(outSum);

		let refundSum = response.REC.reduce((total, amt) => {
			if(amt.ACCT_TYPE !='출연계좌') return Number(amt.IN_AMT) + total
			else return total
		}, 0);
		setTotalRefundAmt(refundSum);


		//전체ROW개수
		totalCnt.current = Object.keys(result).length+'';
		setTotalRowCnt(Object.keys(result).length);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		//데이터 처리
		ib.data = result;


		// @ts-ignore
		sheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}


			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(Number(sr) / Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInoutGubun(event.target.value);
	};


	async function SetDate(value){
		const newEndDate = new Date();
		setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
		const newStartDate = new Date(newEndDate);
		newStartDate.setDate(newEndDate.getDate() - value);
		setStartDate(newStartDate);  // 시작 날짜를 조정
	}


	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function getOzReportInvoice(acct_date, in_amt, out_amt, vacct_no){
		let print_date = '';
		let date = new Date();
		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		const hours = date.getHours();
		const minutes = date.getMinutes();
		const seconds = date.getSeconds();


		print_date = year+'-'+dateLpad(month)+'-'+dateLpad(day);
		if (hours > 12) {
			const pmHours = hours - 12;
			print_date += ' 오후 ' + pmHours + ':' + minutes + ':' + seconds;
		} else {
			print_date += ' 오전 ' + hours + ':' + minutes + ':' + seconds;
		}


		UIUtils.openOZReportViewerPopup({
			title: "입출금내역 명세서",
			reportName: "invoice",
			parameter: {
				"connection.pcount": "6",
				"connection.args1": "acct_date="+acct_date,
				"connection.args2": "in_amt="+in_amt,
				"connection.args3": "out_amt="+out_amt,
				"connection.args4": "vacct_no="+vacct_no,
				"connection.args5": "bank_nm=하나",
				"connection.args6": "print_date="+print_date,
				"information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
				// "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
				// "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시

				"pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
				"pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부

				"export.format":"pdf", // 저장포맷
				"export.filename": "입출금내역 명세서" + ".pdf", // 파일명
				"export.mode":"silent", // 설정창 보여줄지 여부

				"viewer.pagedisplay":"continuous", // 페이지 표시 옵션
				"viewer.viewmode":"normal", // 보고서 보기 모드
				"viewer.zoom": "90"
			},
			onClose: () => {
				console.log("Report Viewer Close");
			}
		})
	}




	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={3} lnbIdx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">입출금내역조회</h1>
					<div className="sf  sf-fund">
						<div className="inner">
							<div className="sf-item sf-m-1-4">
								<p className="sf-key">거래일</p>
								<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={startDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={endDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-root hz-gap5">
											<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(90); setDateNum(1); } }>이전 3개월</Button>
											<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(180); setDateNum(2); } }>이전 6개월</Button>
											<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(365); setDateNum(3); } }>이전 12개월</Button>
											<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={()=> { SetDate(730); setDateNum(4); } }>이전 24개월</Button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">계좌구분</p>
								<div className="sf-value">
									<div className="hz-root hz-gap5">
										<div className="sl sl-md w180">
											<select name="refundCheckYn" id="refundCheckYn" value={refundCheckYn} onChange={(handleSelect)}>
												<option value="">전체</option>
												<option value="N">출연계좌</option>
												<option value="Y">환수계좌</option>
											</select>
										</div>
										{ refundCheckYn == '' && <UIInput className={'tf tf-md hz-item hz-fg'} value={''} placeholder={''} disabled={true} /> }
										{ refundCheckYn != '' && <UIInput className={'tf tf-md hz-item hz-fg'} value={vacctNo} valueChanged={(value) => {setVacctNo(value)}} placeholder={''} readOnly={true}  /> }
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">거래구분</p>
								<div className="sf-value">
									<div className="hz-root hz-gap15">
										<label htmlFor="rd-1-1" className="ip-rd-label">
											<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value={''} checked={inoutGubun == ''} onChange={handleOptionChange} />
											<span className="check"></span>
											<span className="txt">전체</span>
										</label>
										<label htmlFor="rd-1-2" className="ip-rd-label">
											<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value={'2'} checked={inoutGubun == '2'} onChange={handleOptionChange} />
											<span className="check"></span>
											<span className="txt">입금</span>
										</label>
										<label htmlFor="rd-1-3" className="ip-rd-label">
											<input name="rd-1" id="rd-1-3" className="ip-rd" type="radio" value={'1'}checked={inoutGubun == '1'} onChange={handleOptionChange} />
											<span className="check"></span>
											<span className="txt">출금</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb25">
						<Button color="pri" size="md" onClick={()=> doSearch('search')}>조회</Button>
					</div>
					<div className="tb-top">
						<div className="hz-root hz-center">
							<p className="tx fc-black">총 <em className="fw500">{totalRowCnt}</em>건</p>
							<div className="price-summary">
								<div className="items">
									<label className="fc-err">입금액</label><strong className="price">{StringUtil.formatNumber(Number(totalInAmt))}</strong>원
								</div>
								<span className="sign">-</span>
								<div className="items">
									<label className="fc-pri">출금액</label><strong className="price">{StringUtil.formatNumber(Number(totalOutAmt))}</strong>원
								</div>
								<span className="sign">=</span>
								<div className="items">
									<label className="total">총 잔액</label><strong className="price">{StringUtil.formatNumber(Number(totalInAmt)-Number(totalOutAmt))}</strong>원
								</div>
								<span className="sign"></span>
								<div className="items">
									<label className="fc-err">환수총액</label><strong className="price">{StringUtil.formatNumber(Number(totalRefundAmt))}</strong>원
								</div>
							</div>
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>									
						</div>
					</div>
					<div className={'w100p'}>
						<div id='sheetDiv'>[D] IBSHEET 영역</div>
					</div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;